import { fetchBasicJsonPostJson, fetchBasicJsonPost } from '@/script/common';

export default {
    getData: (page, itemsPerPage, filter, signal) => {
        var parameters = {
            page: page,
            pageSize: itemsPerPage
        };
        parameters.code =
            filter.code && /^\d+$/.test(filter.code) ? +filter.code : null;
        parameters.branch_code =
            filter.branch_code && /^\d+$/.test(filter.branch_code)
                ? +filter.branch_code
                : null;
        parameters.branch_code_or_zero =
            filter.branch_code_or_zero &&
            /^\d+$/.test(filter.branch_code_or_zero)
                ? +filter.branch_code_or_zero
                : null;
        parameters.name = filter.name || null;
        parameters.search = filter.search || null;
        parameters.include_deleted = filter.include_deleted || null;
        parameters.hasWard = filter.hasWard === true;
        parameters.hasDepartmentAccessWithType = filter.hasDepartmentAccessWithType || null;
        return fetchBasicJsonPostJson(
            '/Department/GetDataTableData',
            {
                data: parameters,
                signal: signal
            },
            {
                useBlock: !signal
            }
        );
    },
    add: item => {
        return fetchBasicJsonPost('/Department/Add', {
            data: item
        });
    },
    edit: item => {
        return fetchBasicJsonPost('/Department/Edit', {
            data: item
        });
    }
};
